export const TRANSCRIPT_BOTTOM_TOLERANCE_PX = 12;

export function isTranscriptAtBottom({
  scrollTop,
  scrollHeight,
  clientHeight,
}: {
  scrollTop: number;
  scrollHeight: number;
  clientHeight: number;
}): boolean {
  const distanceFromBottom = Math.max(0, scrollHeight - clientHeight - scrollTop);
  return distanceFromBottom <= TRANSCRIPT_BOTTOM_TOLERANCE_PX;
}
